/** Primary video identifier — 'main' for single-video tasks. Multi-video uses MediaItemT.label. */
export const VIDEO_ID = 'main';

/** U+FFFF — sorts after all valid strings in IDB compound key range upper bounds. */
export const IDB_KEY_UPPER_BOUND = '\uFFFF';

/** Minimum dirty entry count before petitioning for an early flush. */
export const DIRTY_FLUSH_THRESHOLD = 100;

/** Debounce delay before checking flush threshold after writes stabilize. */
export const DIRTY_FLUSH_DEBOUNCE_MS = 300;